/**
 * What the shelf field of an inbound cancel stands for. Declining still names a shelf, because that is
 * the shelf the write-off is taken from [BR-58] — so the field stays open and only its meaning changes.
 */
export const cancelInboundShelfRole = (restock: boolean, writtenOff: number): string => {
  if (!restock) {
    return 'The shelf the units are taken off';
  }
  return writtenOff > 0
    ? `The shelf the units sit on · the ${writtenOff} unit(s) not restocked are taken off this shelf`
    : 'The shelf the units stay on';
};

/** The memo prompt both cancel-inbound dialogs share; the memo also lands in the order's Comments. */
export const CANCEL_INBOUND_MEMO_PLACEHOLDER = 'Why the inbound is cancelled — e.g. damaged on arrival, wrong item';
